import { Component } from '@angular/core';
import { MenuService } from '../core/menu/menu.service';
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent {
  constructor(public menu: MenuService) {}
}
